import {ListView} from '@/lib/definitions'

const utils = {}

utils.resolveIconView = view => {
  switch (view) {
    case ListView.CARD_VIEW:
      return 'view_agenda'
    case ListView.COMPACT_VIEW:
      return 'view_stream'
    case ListView.MINIMAL_VIEW:
      return 'view_headline'
    case ListView.GRID_VIEW:
      return 'grid_on'
    default:
      return 'view_agenda'
  }
}

export default utils
